module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/assessment_achievements/4_f5e6a6579473f995bddea37def05258c.png";